import { render, staticRenderFns } from "./vue-icon-picker.vue?vue&type=template&id=6ec26ce9&scoped=true&"
import script from "./vue-icon-picker.vue?vue&type=script&lang=js&"
export * from "./vue-icon-picker.vue?vue&type=script&lang=js&"
import style0 from "./vue-icon-picker.vue?vue&type=style&index=0&id=6ec26ce9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec26ce9",
  null
  
)

export default component.exports